var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJoystick(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 511.979 511.979",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M138.427,27.05H31.946c-5.883,0-10.648,4.766-10.648,10.648v404.644 c0,5.875,4.765,10.655,10.648,10.655h106.481c5.882,0,10.648-4.78,10.648-10.655V37.698C149.074,31.815,144.309,27.05,138.427,27.05 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#656D78"
    },
    d: "M319.069,58.97c-0.016-5.359-4.016-9.875-9.328-10.546L139.755,27.128 c-3.031-0.375-6.078,0.562-8.367,2.586c-2.297,2.023-3.609,4.93-3.609,7.984v404.644c0,3.047,1.312,5.969,3.601,7.984 c1.961,1.733,4.469,2.671,7.047,2.671c0.445,0,0.883-0.031,1.32-0.094l170.76-21.296c5.328-0.656,9.344-5.203,9.328-10.578 L319.069,58.97z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      fill: "#080808",
      enableBackground: "new"
    },
    points: "319.428,229.371 84.834,229.371 84.834,27.05  63.538,27.05 63.538,229.371 21.298,229.371 21.298,250.668 63.538,250.668 63.538,452.997 84.834,452.997 84.834,250.668  319.475,250.668 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCD1D9"
    },
    d: "M338.537,441.638l-18.89-32.094l-193.65,26.891l-19.523,27.202 c-2.172,3.265,23.882,4.53,25.733,7.983c1.859,3.469,1.594,13.312,5.523,13.312l191.868-26.89c3.891,0,7.484-2.125,9.344-5.547 C340.802,449.076,340.662,444.904,338.537,441.638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AAB2BC"
    },
    d: "M146.676,468.511l-18.897-32.076H21.298L1.79,468.386c-2.18,3.266-2.383,7.469-0.531,10.922 c1.859,3.469,5.461,5.625,9.39,5.625h127.082c3.898,0,7.484-2.125,9.343-5.547C148.942,475.965,148.793,471.793,146.676,468.511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED5564"
    },
    d: "M490.157,314.189c-0.469-1.422-1.234-2.734-2.234-3.828l-21-22.952 c-2.016-2.203-4.874-3.469-7.858-3.469H434.91c-2.344,0-4.641,0.781-6.5,2.219l-9.203,7.108h-113.48l-9.203-7.108 c-1.859-1.438-4.141-2.219-6.5-2.219h-24.147c-2.983,0-5.835,1.266-7.851,3.469l-21,22.952c-1.008,1.094-1.773,2.406-2.25,3.828 c-24.601,73.936-28.351,121.262-11.469,144.667c7.281,10.093,18.101,15.437,31.296,15.437c11.468,0,27.686-5.719,39.873-32.92 c3.344-7.453,5.625-14.844,7.062-20.328h121.871c1.438,5.484,3.719,12.875,7.047,20.328c12.188,27.201,28.421,32.92,39.873,32.92 c13.203,0,24.031-5.344,31.312-15.437C518.515,435.451,514.765,388.125,490.157,314.189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#656D78"
    },
    d: "M340.74,399.749c0,11.765-9.531,21.296-21.296,21.296c-11.766,0-21.297-9.531-21.297-21.296 s9.531-21.296,21.297-21.296C331.209,378.453,340.74,387.984,340.74,399.749z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M319.444,431.701c-17.609,0-31.938-14.344-31.938-31.952s14.328-31.952,31.938-31.952 c17.624,0,31.951,14.344,31.951,31.952S337.068,431.701,319.444,431.701z M319.444,389.094c-5.875,0-10.641,4.78-10.641,10.655 c0,5.874,4.766,10.655,10.641,10.655s10.655-4.781,10.655-10.655C330.099,393.874,325.319,389.094,319.444,389.094z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#656D78"
    },
    d: "M425.925,399.749c0,11.765-9.531,21.296-21.297,21.296c-11.749,0-21.295-9.531-21.295-21.296 s9.546-21.296,21.295-21.296C416.393,378.453,425.925,387.984,425.925,399.749z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M404.628,431.701c-17.608,0-31.936-14.344-31.936-31.952s14.327-31.952,31.936-31.952 c17.625,0,31.953,14.344,31.953,31.952S422.253,431.701,404.628,431.701z M404.628,389.094c-5.858,0-10.64,4.78-10.64,10.655 c0,5.874,4.781,10.655,10.64,10.655c5.875,0,10.656-4.781,10.656-10.655C415.284,393.874,410.503,389.094,404.628,389.094z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFCE54"
    },
    points: "415.253,293.267 308.928,293.267 308.803,325.205 415.284,325.205 "
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoystick);
export default __webpack_public_path__ + "static/media/joystick.41856329cf043b923a28af74e1526085.svg";
export { ForwardRef as ReactComponent };